import { db } from "@/firebaseApp";
import { collection, onSnapshot } from "firebase/firestore";

const clients = {
  namespaced: true,
  state: {
    all: [],
    client: null,
  },
  getters: {
    clientID: (state) => (clientId) => {
        return state.all.find(({id}) => id == clientId)
    },
  },
  mutations: {
    addClient(state, newClient) {
      state.all.push(newClient);
    },
    client(state, client) {
      state.client = client;
    },
  },
  actions: {
    async getAll({ commit }) {
      try {
        const unsub = await onSnapshot( collection(db, "clients"), (querySnapshot) => {
            querySnapshot.docChanges().forEach((change) => {
              const doc = change.doc;
              if (change.type === "added") {
                commit("addClient", { ...doc.data(), id: doc.id });
              }
            });
          }
        );
        commit("client", unsub);
      } catch (error) {
        console.log("ERROR TO GET ALL CLIENTS: " + error);
      }
    },
  },
};

export default clients;
